import { fromJS } from 'immutable'

export const presetState = fromJS({
  id: 0,
  code: '',
})

export const presetDetailState = fromJS({
  id: 0,
  cashier_preset_id: 0,
  fee_id: 0,
  fee_code: '',
  fee_name: '',
  amount: '',
})

const initialState = fromJS({
  list: [],
  items: {},
  hasFetched: false,
  pending: false,
})

export default function preset(state = initialState, action) {
  switch (action.type) {
    case 'PRE_REQ':
      return state.set('pending', true)

    case 'PRE_GET_SUCC':
    case 'PRE_SAVE_SUCC':
    case 'PRE_DEL_SUCC':
    case 'PRE_PF_SAVE_SUCC':
    case 'PRE_PF_DEL_SUCC':
      return state
        .set('pending', false)
        .set('hasFetched', true)
        .set('list', fromJS(action.payload.list || []))
        .set('items', fromJS(action.payload.items || {}))

    case 'NOTIF_FAIL':
      return state.set('pending', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/FeesPresets/reducer.js